import { firestore } from 'firebase/app';
import { CustomerService } from './customer.service';
import { CustomerDao } from './customer.dao';
import { PropertyTypeDao } from './propertyType.dao';
import { DeliveryOptionDao } from './delivery-option.dao';
import { ProductDao } from './product.dao';
import { CurrencyPipe } from '@angular/common';
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/firestore"
import { TrDatePipe } from "../pipes/tr-date.pipe"
import { FirebaseDaoBase } from "../table/daos/firebase-dao-base"
import { AngularFireStorage } from '@angular/fire/storage';
import { ProductService } from './product.service';
import { DeliveryOptionService } from './delivery-option.service';

export class QuoteRepository extends FirebaseDaoBase<any> {
  
  customerId: string;
  productDao: ProductDao
  deliveryOptionDao: DeliveryOptionDao
  propertyTypeDao: PropertyTypeDao
  customerDao: CustomerDao
  constructor(
    private customerService : CustomerService,
    private productService : ProductService,
    private deliveryOptionService : DeliveryOptionService,
    public firestore: AngularFirestore,
    public storage: AngularFireStorage
  ) {
    super()
    this.productDao = new ProductDao(this.productService, storage);
    this.deliveryOptionDao = new DeliveryOptionDao(this.deliveryOptionService);
    this.propertyTypeDao = new PropertyTypeDao(firestore);
    this.customerDao = new CustomerDao(this.customerService);
  }

  public async initializeDetails(): Promise<void> {
    await Promise.all([
      this.productDao.initialize(),
      this.deliveryOptionDao.initialize(),
      this.propertyTypeDao.initialize(),
      this.customerDao.initialize()
    ])
  }

  public getProducts(): any[] {
    return this.productDao.totalData.value
  }

  public getDeliveryOptions(): any[] {
    return this.deliveryOptionDao.totalData.value
  }

  public getPropertyTypes(): any[] {
    return this.propertyTypeDao.totalData.value;
  }

  public getCustomerById(customerId: any) {
    return this.firestore.collection('customers').doc(this.customerId);
  }

  public getCollection(): AngularFirestoreCollection {
    return this.firestore.collection(`customers/${this.customerId}/quotes`)
  }

  deleteQuote(customerId: string, quoteId: string) {
    if (quoteId && customerId) {
      return this.firestore.collection('customers').doc(customerId).collection('quotes').doc(quoteId).delete().then(() => { return true });
    }
    return false;
  }

  public convertValuesToString(dataItem: any, key: string): string {
    switch (key) {
      case "quoteDate":
        return new TrDatePipe().transform(dataItem.quoteDate, "short")
      case "productQuote":
      case "freightQuote":
      case "totalQuote":
        return new CurrencyPipe("en-US").transform(dataItem[key], "USD")
      default:
        return dataItem[key]
    }
  }
}


